import { AuditActivityType } from '@/types/asset-audit';

/**
 * Converts AuditActivityType enum values to user-friendly labels
 */
export function getActivityTypeLabel(activityType: AuditActivityType): string {
  const labels: Record<AuditActivityType, string> = {
    [AuditActivityType.Created]: 'Created',
    [AuditActivityType.Assigned]: 'Assigned',
    [AuditActivityType.Started]: 'Started',
    [AuditActivityType.AssetAudited]: 'Asset Audited',
    [AuditActivityType.ExceptionRaised]: 'Exception Raised',
    [AuditActivityType.ExceptionResolved]: 'Exception Resolved',
    [AuditActivityType.CommentAdded]: 'Comment Added',
    [AuditActivityType.StatusChanged]: 'Status Changed',
    [AuditActivityType.UserAdded]: 'User Added',
    [AuditActivityType.UserRemoved]: 'User Removed',
    [AuditActivityType.Completed]: 'Completed',
    [AuditActivityType.Cancelled]: 'Cancelled',
    [AuditActivityType.Rescheduled]: 'Rescheduled',
    [AuditActivityType.Paused]: 'Paused',
    [AuditActivityType.Resumed]: 'Resumed',
  };

  return labels[activityType] || activityType;
}
